import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

// for affiliate transactions
const schema = getPaginationSchema({ pageSize: 12 });

export function usePageParams() {
  return usePageParamsFromSchema(schema);
}
